/* unplugin-vue-components disabled */import { render } from "./OssUploader.vue?vue&type=template&id=0750b074&scoped=true"
import script from "./OssUploader.vue?vue&type=script&lang=js"
export * from "./OssUploader.vue?vue&type=script&lang=js"

import "./OssUploader.vue?vue&type=style&index=0&id=0750b074&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0750b074"]])

export default __exports__